// extracted by mini-css-extract-plugin
export default {"container":"Signup_container__5Z471","search-address-btn":"Signup_search-address-btn__IfjxG"};